const UNSORTED_DISTRICTS = [
    "300",
    "301",
    "302",
    "303",
    "304",
    "305",
    "306",
    "307",
    "308",
    "311",
    "312",
    "313",
    "314",
    "315",
    "316",
    "317",
    "318",
    "319",
    "320",
    "322",
    "323",
    "324",
    "325",
    "326",
    "327",
    "329",
    "330",
    "332",
    "333",
    "335",
    "352",
    "353",
    "354",
    "356",
    "357",
    "358",
    "359",
    "361",
    "364",
    "365",
    "366",
    "367",
    "369",
    "373",
    "374",
    "375",
    "376",
    "377",
    "379",
    "382",
    "390",
    "501",
    "511",
    "512",
    "522",
    "524",
    "599",
    "805",
    "58I",
    "58Y",
    "B02",
    "B03",
    "B06",
    "H07",
    "H08",
    "H09",
    "CSM / CSA Team",
    "Canada District(s)",
    "Commerical District(s)",
    "Corporate Office",
    "Customer Success Managers /Associate",
    "External - Channel/Small Business",
    "FSS Central Midwest",
    "FSS East",
    "FSS Inside Safety",
    "FSS West",
    "Govt Function VP, Admin & Ops",
    "Govt National Contracts Federal NGSMs",
    "Govt National Contracts GSMs- North",
    "Govt National Contracts GSMs- South",
    "Govt National Contracts GSMs- West",
    "Govt National Contracts SLED NGSMs",
    "Health Systems - Central",
    "Health Systems - North",
    "Health Systems - West",
    "Healthcare Function (VP, Admin & Ops)",
    "Healthcare GPOs",
    "Manufacturing Sales",
    "N/A",
    "National Accounts",
    "Puerto Rico District(s)"
] as const;

export const DISTRICTS = Array.from(UNSORTED_DISTRICTS).sort((a, b) => a.localeCompare(b));
